import undoable from 'redux-undo';
import { LogoMakerState } from '.';
import { LogoMakerStateDispatchActions } from './types';
import { Reducer } from 'redux';
import { getInitialState } from './getInitialState';
import { IModule } from 'redux-dynamic-modules';
import { useActions } from './actions/useActions';
import { useAppDispatch } from '@Utils/core/redux/useAppDispatch';
import { useAppSelector } from '@Utils/core/redux/useAppSelector';
import { RootState } from '@Utils/core/redux';
import { useLoadFromStorage } from './useLoadFromStorage';
import { useSaveToStorage } from './useSaveToStorage';
import { LOGO_MAKER_STORAGE_KEY } from './constants';

const logoMakerReducer: Reducer<LogoMakerState, LogoMakerStateDispatchActions> = (
  state = getInitialState(),
  action,
) => {
  switch (action.type) {
    case 'updateField': {
      if (action.payload.subfield) {
        const prevValue = state.configuration[action.payload.field];
        const prevSubState = typeof prevValue === 'object' ? prevValue : {};

        return {
          ...state,
          configuration: {
            ...state.configuration,
            [action.payload.field]: {
              ...prevSubState,
              [action.payload.subfield]: action.payload.value,
            },
          },
        };
      }

      return {
        ...state,
        configuration: {
          ...state.configuration,
          [action.payload.field]: action.payload.value,
        },
      };
    }

    case 'loadFromStorage': {
      return {
        ...state,
        configuration: { ...action.payload },
        loaded: true,
      };
    }

    default:
      return state;
  }
};

export const undoableLogoMakerReducer = undoable(logoMakerReducer);

export const canUndoSelector = (state: RootState) => state.undoableLogoMaker.past.length > 0;
export const canRedoSelector = (state: RootState) => state.undoableLogoMaker.future.length > 0;

export function useUndoableLogoMakerState() {
  const dispatch = useAppDispatch();
  const presentState = useAppSelector((state: RootState) => state.undoableLogoMaker.present);
  const actions = useActions(dispatch);

  useLoadFromStorage(dispatch);
  useSaveToStorage(presentState, LOGO_MAKER_STORAGE_KEY);

  return { presentState, dispatch, actions };
}

export function getUndoableLogoMakerModule(): IModule<typeof undoableLogoMakerReducer> {
  return {
    id: 'undoable-logo-maker-dynamic-module',
    reducerMap: { undoableLogoMaker: undoableLogoMakerReducer },
  };
}
